<div class="menu" *ngIf="editMode">
  <div class="block">
    <a (click)="edit()">
      <ico ico="edit_24"></ico>
    </a>
    <a (click)="delete()">
      <ico ico="delete_24"></ico>
    </a>
  </div>
</div>
<div [class.not-published]="!isPublished" class="publication-content">
  <div class="pub-left">
    <div class="tag" *ngIf="publication.tag">{{publication.tag}}</div>
    <h4>{{publication.name}}</h4>
    <div class="excerpt">{{publication.excerpt}}</div>
    <div class="date">{{publication.publishedAt | date : 'dd.MM.yy'}}</div>
    <a class="btn outline" [routerLink]="publication.link">
      Подробнее
    </a>
  </div>
  <div class="pub-right">
    <img *ngIf="image" [src]="image" alt="">
  </div>
</div>


